module.exports = __webpack_public_path__ + "static/media/unedit.39149fdb.svg";